import AddIcon from '@mui/icons-material/Add';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useAppSelector } from 'store/store';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { ToolbarAction } from 'components/enhanced/types/toolbar.types';
import { useIsDirector } from 'shared/permissions/useIsDirector';
import { useIsSupplier } from 'shared/permissions/useIsSupplier';
import { useIsTechnician } from 'shared/permissions/useIsTechnician';
import { useIsTechnicianCoordinator } from 'shared/permissions/useIsTechnicianCoordinator';
import { useIsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import { NotOperatorRoles } from 'shared/permissions/roles';
import TenantPage from 'layouts/TenantPage';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { equipmentApi } from '../api/equipmentApi';
import { useEquipmentIvdrOptions } from '../hooks';
import { EquipmentColumns } from '../equipments';

export const Equipments = () => {
  const translationPrefix = 'pages.equipment.list';
  const { t } = useTranslation();
  const navigate = useNavigate();
  const datagridRefresh = useRef(null);
  const groups = useAppSelector((state) => state.auth.groups);
  const { ivdrOptions } = useEquipmentIvdrOptions();

  const isDisabledEdit =
    useIsTechnicianCoordinator() || useIsTechnician() || useIsDirector() || useIsSupplier();

  const columns: GridColDef[] = EquipmentColumns(
    ivdrOptions.map((ivdrOption) => ivdrOption.display_name),
    datagridRefresh.current,
    NotOperatorRoles.some((role) => groups.includes(role))
  );

  const toolbarActions: ToolbarAction[] = [
    {
      id: 'add',
      label: t(`${translationPrefix}.add`),
      variant: 'contained',
      startIcon: <AddIcon />,
      visible: useIsTenantAdministrator(),
      onClick: () => {
        navigate(`/tenant/equipments/new`);
      }
    }
  ];

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <EnhancedDataGrid
        columns={columns}
        service={equipmentApi.listService}
        warehouseFilterParam="warehouse_code"
        refresh={datagridRefresh}
        disableEdit={isDisabledEdit}
        useGenericToolbar={true}
        genericToolbarConfig={{
          filters: [],
          actions: toolbarActions
        }}
      />
    </TenantPage>
  );
};

export default Equipments;
